module.exports = __webpack_public_path__ + "assets/9803e740fd9a2ffd7379fdd8c6444562.svg";